import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCareNow } from '~/components/CareTeam/hooks/useGetCareNow';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';
import { useTrackNavTile } from '../../hooks/useTrackNavTile';
import { analyticsTrackEvent } from '~/core/analytics';
import {
  NAV_TILE_CLICKED,
  DRAWER_TYPE_TELEMED,
  DRAWER_TYPE_COVID_TEST,
} from '~/core/analytics/events';

const BookCovidTest = () => {
  useTrackNavTile('covid');

  const goToGetCare = useGetCareNow('covid');

  const onClick = () => {
    goToGetCare();
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      type: DRAWER_TYPE_COVID_TEST,
    });
  };
  const { t } = useTranslation(['account']);

  return (
    <Root onClick={onClick}>
      <Icon
        alt="Illustration of the COVID-19 virus"
        src="/images/account/tiles/covidtest-new.svg"
      />

      <Details>
        <Title>{t('account:navTiles.covidTest.title')}</Title>
        <SubTitle>{t('account:navTiles.covidTest.subtitle')}</SubTitle>
      </Details>
    </Root>
  );
};
export default BookCovidTest;
